import { useState } from "react";
import "../../styling/Dashboard.css";
import axios from "axios";
import { useEffect } from "react";
import defaultPic from "../../images/defaultPic.svg"

const ClientOverviewPanel = ({ clientId }) => {
  const [members, setMembers] = useState([]);
  const [total, setTotal] = useState(0);
  const [lastBookings, setLastBookings] = useState([]);

  const fetchClientInfo = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/clientDetails/${clientId}`,
        { withCredentials: true }
      );
      setTotal(res.data.data.bookingsTotal);
      setLastBookings(res.data.data.last3Events);
      setMembers(res.data.data.teamMembers);
    } catch (error) {
      console.error("Failed to fetch client Info", error);
    }
  };

  useEffect(() => {
    fetchClientInfo();
  }, []);

  return (
    <div>
      <div>
        <div className="right-panel-content-business-overview" style={{ marginTop: '0px' }}>
          <div className="event-total-div">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
              className="event-total-box"
            >
              <div>
                <h4
                  style={{
                    color: "#000000",
                    marginTop: "0px",
                    marginBottom: "5px",
                    fontWeight: "400",
                  }}
                >
                  Bookings Total:
                </h4>
                <h1
                  style={{
                    color: "#000000",
                    marginBottom: "20px",
                    marginTop: "5px",
                  }}
                >
                  $ {total}
                </h1>
              </div>
            </div>

            <div className="mt-4">
              <h4
                style={{
                  color: "#000000",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "400",
                }}
              >
                Last Bookings Dates
              </h4>
              {lastBookings.map((booking, index) => {
                const date = new Date(booking.eventDate);
                const formattedDate = date.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                });

                return (
                  <p key={index} style={{ lineHeight: "10px" }}>
                    {formattedDate}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          width: "89.5%",
          border: "1px solid #D9D9D9",
          borderTop: "none",
          borderLeft: "none",
          borderRight: "none",
          padding: "5%",
        }}
        className="overview-members-container"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            width: "87%",
          }}
        >
          <h4
            style={{
              fontWeight: "800",
              color: "#000000",
              marginTop: "0px",
              fontSize: "15px",
            }}
          >
            {" "}
            Previously Assigned Team Members
          </h4>
        </div>
        <div style={{ marginTop: "12px" }}>
          {Array.isArray(members) && members.length > 0 ? (
            members.map((member, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  padding: "6px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    borderRadius: "50%",
                    overflow: "hidden",
                    marginRight: "12px",
                    width: "50px",
                    height: "50px",
                    flexShrink: 0,
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <img
                    src={member.profilePic || defaultPic}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <div>
                  <h4 style={{ margin: 0, fontWeight: "500", color: "#000" }}>
                    {member.firstName + " " + member.lastName}
                  </h4>
                  <p style={{ margin: 0, color: "#625C73", fontSize: "14px" }}>
                    {member.designation || "Booth Attendant"}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p style={{ color: "#888", marginTop: "8px" }}>
              No team members assigned.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientOverviewPanel;
